import { ExpandTextEditorButton } from './ExpandTextEditorButton';
import {
  customizeIcons,
  defaultColors,
  defaultHighlightColors,
} from 'components/TextEditorModal/TextHelper';
import './CustomToolbar.scss';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
export const modules = {
  toolbar: {
    container: '#custom-toolbar',
  },
  resize: {
    locale: {},
  },
  imageDropAndPaste: {},
};

export const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'color',
  'background',
  'align',
  'bullet',
  'list',
  'strike',
  'link',
  'image',
  'clean',
  'expand',
  'width',
];

type CustomToolbarProps = {
  label?: string;
  isRequired?: boolean;
  name: string;
  placeholder: string;
  isDisabled?: boolean;
  'data-testid'?: string;
  onSubmit?: (e?: React.BaseSyntheticEvent) => void;
  id: string;
  isModal?: boolean;
};

export const CustomToolbar = (props: CustomToolbarProps) => {
  const { t } = useTranslation();
  const headings = [
    { value: '1', label: t('components:custom_toolbar.headings.1') },
    { value: '2', label: t('components:custom_toolbar.headings.2') },
    { value: '3', label: t('components:custom_toolbar.headings.3') },
    { value: '4', label: t('components:custom_toolbar.headings.4') },
    { value: '5', label: t('components:custom_toolbar.headings.5') },
    { value: '6', label: t('components:custom_toolbar.headings.6') },
    { value: '', label: t('components:custom_toolbar.headings.normal') },
  ];
  useEffect(() => {
    customizeIcons();
  }, []);

  return (
    <div id={props.id} className="toolbar-container">
      <div className="ql-formats toolbar-left">
        <select className="ql-header" defaultValue="">
          {headings.map((heading) => (
            <option key={heading.value} value={heading.value}>
              {heading.label}
            </option>
          ))}
        </select>
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        <select className="ql-color">
          {defaultColors.map((color) => (
            <option key={color} value={color} />
          ))}
        </select>
        <select className="ql-background">
          {defaultHighlightColors.map((color) => (
            <option key={color} value={color} />
          ))}
        </select>
        <select className="ql-align" />
        <button className="ql-list" value="bullet" />
        <button className="ql-list" value="ordered" />
        <button className="ql-strike" />
        <button className="ql-link" />
        <button className="ql-image" />
        <button className="ql-clean" />
      </div>
      {!props.isModal && (
        <span className="ql-formats">
          <ExpandTextEditorButton {...props} />
        </span>
      )}
    </div>
  );
};

export default CustomToolbar;
